// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7395) return "css/design_system-a8d86e0d4d9168df364f.css";
	if (chunkId === 4955) return "css/4955-26df6bfbbb1076dde711.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2508":"fcf709e1890ff4fc4a91","4770":"c58b150c54662ae0fa67","7749":"5db96468dd527b32323b","9440":"6d98cd56e4bbd496a521"}[chunkId] + ".css";
};